export const sourceLabels = { web: "Web", reserva: "Reserva", cancion: "Petición de canción", importado: "Importado", manual: "Manual" };
